import { Booking } from "../models/booking";
import { CarModel } from "../models/CarModel";
import { AuthDetails } from "../models/AuthDetails"
import { User } from "../models/User";
import { UserEnquiryLog } from "../models/UserEnquiryLog";

export class AppContext {

    static phone = '';
    static authDetails: AuthDetails
    static partnerId: string = "666c6b2381bce16768a7b634"
    static User: User | null
    static booking: Booking;
    static bookings: Booking[];
    static selectedUserBookings: Booking[];
    static id: number
    static emptyObjectId: string = "000000000000000000000000";
    static bookingName: string;
    static travelDate: string = '';
    static travelTime: string = '';
    static selectedCar: CarModel
    static selectedRoute: string = ""
    static selectedSourceTerminal: string = ""
    static selectedDestinationTerminal: string = ""
    static isLastMinuteFareEligible: boolean
    static isFirstRide : boolean

    static selectedEnquiry : UserEnquiryLog 

    static AddUserAndBookRide: boolean = true;

    static secreteKey: string = "3fa6aefc52e9c6d1898db9b4d6b51c8e3b77b98b2086d6523e4c89124f86a117";
    static loggedUserId: string
    static loggedAuthToken: string
    static grpLastMinuteBooking: boolean = false;
    static clearAll() {


    }

    static getBooking(): Booking {
        return this.booking;
    }

    static setBooking(booking: Booking) {
        this.booking = booking;
    }

    static getBookings(): Booking[] {
        return this.bookings;
    }

    static setBookings(bookings: Booking[]) {
        this.bookings = bookings;
    }

    static getBookingId(): number {
        return this.id;
    }

    static setBookingId(id: number) {
        this.id = id;
    }






}


